<template>
  <div>
    <el-table border :data="data" style="width: 100%" size="mini">
      <el-table-column label="触发事件" min-width="110px">
        <template slot-scope="{row}">
          <span v-if="row.EventType==0">用户注册</span>
          <span v-if="row.EventType==1">消费次数</span>
          <span v-if="row.EventType==2">消费金额</span>
        </template>
      </el-table-column>
      <el-table-column prop="LeastValue" label="事件值" min-width="120px" />
      <slot name="column"></slot>
    </el-table>
    <edit-dialog ref="editDialog" in-dialog @on-saved="onSaved" />
  </div>
</template>
<script>
import editDialog from "./editDialog";
export default {
  components: { editDialog },
  data() {
    return {
      api: require("@/api/sale/couponAuto").default,
      CouponId: null,
      data: [],
    };
  },
  computed: {},
  methods: {
    setData(CouponId) {
      
      this.CouponId = CouponId;
      this.getData();
    },
    getData() {
      
      if (this.CouponId) {
        this.api.list({ CouponId: this.CouponId }).then((res) => {
          
          this.data = res.Data;
        });
      }
    },
    add(data) {
      this.$refs.editDialog.openCreate(data);
    },
    edit(row) {
      this.$refs.editDialog.openEdit(row);
    },
    onSaved(data) {
      
      let auto = this.data.find((x) => x.AutoId == data.AutoId);
      if (auto == undefined) {
        this.data.push(data);
      } else {
        auto.EventType = data.EventType;
        auto.LeastValue = data.LeastValue;
      }
      
    },
    del(row, index) {
      
      this.api.delete({ id: row.AutoId }).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.data.splice(index, 1);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    clear() {
      this.data = [];
    },
  },
};
</script>